import Flex from "@irati/ui/src/Flex"
import Icon from "@irati/ui/src/Icon"
import {Card} from "@irati/ui/src/Layout"
import Link from "@irati/ui/src/Link"
import {Label} from "@irati/ui/src/Typography"
import styled, {css} from "styled-components"

interface Props {
  completed?: boolean
  current?: boolean
  active?: boolean
  step?: number
  small?: boolean
}

interface MobileFlexProps {
  mobileWidth?: string
}

export const StatusDot = styled.button<Props>`
  position: relative;
  width: 34px;
  height: 34px;
  bottom: 16px;
  border: 2px solid
    ${({current, theme}) => {
      if (current) {
        return theme.colors.primary1
      }
      return theme.colors.greys.lightest
    }};
  background: ${({completed, theme}) => (!completed ? theme.colors.greys.white : theme.colors.primary1)};
  border-radius: 100px;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  ${({theme, completed}) =>
    completed &&
    `
      cursor: pointer;
      &:hover {
        cursor: pointer;
        border: 2px solid ${theme.colors.primary1};
        span {
          font-family: ${theme.font.bold};
        }
      }
    }
  `}

  ${({current}) => current && `cursor: pointer;`}

  ${({theme, active}) =>
    active &&
    `
    :before {
      content: " ";
      position: absolute;
      top: -${theme.spacing.one};
      left: -${theme.spacing.one};
      right: -${theme.spacing.one};
      bottom: -${theme.spacing.one};
      border-radius: 50%;
    }
  `}
`

export const SignUpWrapper = styled.div`
  ${({theme}) => css`
    background-color: ${theme.colors.greys.grey03};
    padding-bottom: 128px;
  `}
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    background: white;
    padding-bottom: 0;
  `}
`

export const Line = styled.div<Props>`
  height: 2px;
  width: 100%;
  background: ${({completed, theme}) => (completed ? theme.colors.primary1 : theme.colors.greys.lightest)};
`

export const Relative = styled.div`
  position: relative;
`

export const Absolute = styled.div<Props>`
  position: absolute;
  width: ${({step}) => (step && step > 2 ? "165px" : "200px")};
  left: ${({step}) => (step && step > 2 ? "-60px" : "-90px")};
  top: 35px;
  text-align: center;
`

export const RelativeBody = styled.div`
  position: relative;
  top: -30px;
  right: ${({firstItem, lastItem}) => {
    if (firstItem) {
      return "8px"
    }
    if (lastItem) {
      return "140px"
    }
    return "50px"
  }};
  width: ${({firstItem, lastItem}) => {
    if (firstItem) {
      return "110px"
    }
    if (lastItem) {
      return "165px"
    }
    return "125px"
  }};
`

export const StyledLabel = styled(Label)`
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    display: none;
  `}
`

export const StyledCard = styled(Card)`
  max-width: ${({maxWidth}) => maxWidth || "939px"};
  margin: 40px auto;
  ${({theme}) => css`
    background:
      linear-gradient(white, white) padding-box,
      linear-gradient(67deg, ${theme.colors.primary1} 0%, ${theme.colors.secondary1} 100%) border-box;
  `}
  border-radius: 12px;
  border-top: 8px solid transparent;
  align-self: self-start;

  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    border: none;
    border-radius: 0;
    background: white;
    margin: 0;
    box-shadow: none;
    width: 100%;
  `}
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    margin: ${({marginTop}) => marginTop || "0px"} auto 0;
   `}
`

export const StyledTopCard = styled(Card)`
  max-width: 939px;
  margin: 40px auto;
  ${({theme}) => css`
    background: ${theme.colors.secondary1_50};
  `}
  ${({theme}) => theme.mediaQueries.maxWidthMedia.desktop`
    margin: 0px auto;
  `}
`

export const StyledStepCard = styled(Card)`
  height: 138px;
  width: 200px;
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
     width: 100%;
    `}
  `}
`

export const StyledFlex = styled(Flex)`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
      flex-direction: column;
    `}
  `}
`

export const StyledIcon = styled(Icon)`
  path:first-of-type {
    fill: ${({theme}) => theme.colors.primary2};
  }
`

export const NorthrowLabel = styled(Label)`
  font-size: 10px;
`
export const TermsWrapper = styled(Flex)`
  ${({theme}) => css`
    border: 1px solid #b3dfff;
    border-radius: ${theme.border.radius.large};
    background-color: ${theme.colors.greys.white};
    ${theme.mediaQueries.minWidthMedia.tablet`
       width: calc(100% - 30px);
    `}
  `}
`

export const FullWidth = styled.div`
  width: 100%;
`

export const DesktopOnlyWrapper = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
      display: none;
    `}
  `}
`

export const MobileOnlyWrapper = styled.div`
  ${({theme}) => css`
    ${theme.mediaQueries.minWidthMedia.desktop`
      display: none;
    `}
  `}
`

export const MobileFlex = styled(Flex)<MobileFlexProps>`
  ${({theme, mobileWidth}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
    width: ${mobileWidth};
  `}
  `}
`

export const FooterFlex = styled(Flex)`
  height: 32px;
  position: fixed;
  bottom: 0%;
  width: 100%;
  padding-right: 80px;
  background: ${({theme}) => theme.colors.primary1};
  ${({theme}) => css`
    ${theme.mediaQueries.maxWidthMedia.desktop`
      display: none;
    `}
  `}
`

export const StyledLink = styled(Link)`
  &:hover {
    color: ${({theme}) => theme.colors.greys.white};
    box-shadow: 0px 2px 0px ${({theme}) => theme.colors.greys.white};
  }
`
